const SEGMENT_HOST = 'eec.stage.crunchyroll.com/v1'
const FALLBACK_SEGMENT_HOST = 'sa.etp-staging.com/analytics.js/v1/'
const SSO_URL = 'https://sso.stage.crunchyroll.com'
const AVATARS_STATIC_URL = 'https://static.etp-staging.com'
const DEFAULT_ACCESS_TOKEN = process.env.GATSBY_DEFAULT_ACCESS_TOKEN || ''
const DEV_SEGMENT_WRITE_KEY = process.env.GATSBY_DEV_SEGMENT_WRITE_KEY || ''
const DEV_SEGMENT2_SOURCE_ID = process.env.GATSBY_DEV_SEGMENT2_SOURCE_ID || ''
const DEV_SEGMENT2_WRITE_KEY = process.env.GATSBY_DEV_SEGMENT2_WRITE_KEY || ''
const ANON_API_AUTH_ID = process.env.GATSBY_ANON_API_AUTH_ID || ''

const STORYBLOK_API_TOKEN_OBJ = {
  storyblok: {
    token:
      process.env.GATSBY_STORYBLOK_TOKEN || '',
    version: process.env.GATSBY_STORYBLOK_VERSION || 'published',
  },
}

export default {
  deviceType: 'com.crunchyroll.static',
  accessToken: DEFAULT_ACCESS_TOKEN,
  segment: {
    segmentHost: SEGMENT_HOST,
    fallbackLibraryHost: FALLBACK_SEGMENT_HOST,
    writeKey: DEV_SEGMENT_WRITE_KEY,
  },
  segmentGen2: {
    segmentHost: SEGMENT_HOST,
    fallbackLibraryHost: FALLBACK_SEGMENT_HOST,
    sourceId: DEV_SEGMENT2_SOURCE_ID,
    writeKey: DEV_SEGMENT2_WRITE_KEY,
  },
  ...STORYBLOK_API_TOKEN_OBJ,
  ssoUrl: SSO_URL,
  avatarsStaticUrl: AVATARS_STATIC_URL,
  endpoints: {
    authUrl: '/auth/v1/token',
    accountUrl: '/accounts/v1/me',
    profileUrl: '/accounts/v1/me/multiprofile',
    subscriptionUrl: '/subs/v1/subscriptions',
    benefitsUrl: '/benefits',
    eligibilityUrl:
      '/eligibility/cr_premium.1_month?action=free_trial_preliminary',
  },
  anonApiAuthId: ANON_API_AUTH_ID,
}
